import {useParams} from 'react-router-dom';
import {useAuth} from '../context/useAuth';
import {P0AlertsWorkspace} from '../components/p0alerts/P0AlertsWorkspace';

export function P0AlertsPage() {
  const {user} = useAuth();
  const {id} = useParams<{id: string}>();
  const canDecide = user?.role === 'analyst_admin' || user?.role === 'admin';

  return <P0AlertsWorkspace canDecide={canDecide} focusAlertId={id} />;
}
